import {isEmpty, startCase} from 'lodash'
import React from 'react'
import {Container, Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'

type Props = {
  handleClose?: () => void
  response?: any
}

const ValidationErrorModal: React.FC<Props> = ({handleClose, response}) => {
  const intl = useIntl()
  const dataErrors = response?.data
  const fileErrors = dataErrors?.error?.fields

  const renderError = (error: string, index: number) => {
    const [input, messageId, max] = error.split('|')

    return (
      <li key={index} className='fw-bolder text-danger'>
        {intl.formatMessage(
          {id: messageId || input},
          {
            input: input
              ? intl.formatMessage({id: input.toUpperCase(), defaultMessage: startCase(input)})
              : '',
            max: max || '',
          }
        )}
      </li>
    )
  }

  const renderErrors = (errorList: string[]) => {
    return errorList?.map((error, index) => renderError(error, index))
  }

  return (
    <Modal
      id='gori_order_modal_error'
      tabIndex={-1}
      aria-hidden='true'
      centered
      show={!isEmpty(response)}
      onHide={handleClose}
    >
      <div className='modal-content'>
        <Modal.Header closeButton>
          <Modal.Title bsPrefix={'fw-bolder fs-1'}>
            {intl.formatMessage({id: 'ERRORS'})}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='vh-75 scroll-y bg-light-danger text-danger'>
          <Container>
            {dataErrors?.message && (
              <div className='fw-bolder fs-3 mb-5 text-center'>
                {!isEmpty(dataErrors?.errors)
                  ? intl.formatMessage({id: 'VALIDATION_ERRORS'})
                  : dataErrors?.message}
              </div>
            )}
            {!isEmpty(dataErrors?.errors) &&
              Object.entries(dataErrors?.errors).map(([key, errors]: any, index: number) => (
                <div className='fw-bolder fs-5 mt-2' key={index}>
                  <ul>
                    {errors.map((error: any, index: number) => (
                      <li key={index} className='ms-4'>
                        {typeof error === 'string'
                          ? error
                          : error?.message || JSON.stringify(error)}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            {!isEmpty(fileErrors) &&
              Object.values(fileErrors).map((item: any, index) => (
                <div key={index}>
                  <div className='col-12'>
                    {item?.error && (
                      <div className='fw-bolder text-dark'>
                        {intl.formatMessage({id: 'ROW'})}: {parseInt(item?.row as string)}
                      </div>
                    )}
                  </div>
                  <div className='col-auto'>{renderErrors(item?.error || item)}</div>
                </div>
              ))}
          </Container>
        </Modal.Body>
      </div>
    </Modal>
  )
}

export {ValidationErrorModal}
